import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "insta-home" }
const _hoisted_2 = { class: "hero-section" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "hero-title" }, "Instagram 맞팔 확인", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "hero-subtitle" }, " 누가 나를 언팔했을까? 데이터를 업로드하고 바로 확인하세요. ", -1)
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"feature-cards\"><div class=\"feature-card\"><div class=\"feature-icon\">🔍</div><div class=\"feature-title\">언팔 감지</div><div class=\"feature-desc\"> 내가 팔로우하지만 나를 팔로우하지 않는 사람을 찾아줍니다. </div></div><div class=\"feature-card\"><div class=\"feature-icon\">📁</div><div class=\"feature-title\">ZIP 업로드</div><div class=\"feature-desc\"> 인스타그램에서 받은 ZIP 파일을 그대로 업로드하면 자동 분석합니다. </div></div><div class=\"feature-card\"><div class=\"feature-icon\">🔒</div><div class=\"feature-title\">완전한 개인정보 보호</div><div class=\"feature-desc\"> 어떠한 정보도 서버로 전송되지 않습니다. 오프라인에서도 작동합니다. </div></div></div>", 1)
const _hoisted_6 = { class: "guide-section" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", { class: "section-title" }, "이용 방법", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "section-subtitle" }, " 인스타그램 데이터를 다운로드하는 방법을 안내합니다. ", -1)
const _hoisted_9 = { class: "guide-tab-area" }
const _hoisted_10 = {
  key: 0,
  class: "guide-steps"
}
const _hoisted_11 = { class: "guide-step" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "1", -1)
const _hoisted_13 = { class: "step-content" }
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"step-title\">데이터 다운로드 페이지 이동</div><div class=\"step-desc\"> 아래 링크를 클릭하여 인스타그램 데이터 다운로드 페이지로 이동하세요. 이동 후 <span class=\"highlight\">계속</span> 버튼을 클릭합니다. </div><div class=\"step-link\"><a href=\"https://www.instagram.com/download/request/\" target=\"_blank\" rel=\"noopener noreferrer\">인스타그램 데이터 다운로드 →</a></div>", 3)
const _hoisted_17 = { class: "step-images" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "guide-step" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "2", -1)
const _hoisted_21 = { class: "step-content" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "정보 다운로드 또는 전송 선택", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "step-desc" }, [
  /*#__PURE__*/_createTextVNode(" 내 정보 다운로드 항목에서 "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "정보 다운로드 또는 전송"),
  /*#__PURE__*/_createTextVNode("을 클릭하세요. ")
], -1)
const _hoisted_24 = { class: "step-images" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "guide-step" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "3", -1)
const _hoisted_28 = { class: "step-content" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "계정 선택 및 일부 정보 선택", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "step-desc" }, [
  /*#__PURE__*/_createTextVNode(" 내 계정 및 프로필에서 원하는 계정을 선택한 뒤, "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "일부 정보 항목"),
  /*#__PURE__*/_createTextVNode("을 선택하세요. ")
], -1)
const _hoisted_31 = { class: "step-images" }
const _hoisted_32 = ["src"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "guide-step" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "4", -1)
const _hoisted_36 = { class: "step-content" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "팔로워 및 팔로잉 체크", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "step-desc" }, [
  /*#__PURE__*/_createTextVNode(" 연결 활동 영역에서 "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight-red" }, "팔로워 및 팔로잉"),
  /*#__PURE__*/_createTextVNode(" 항목만 체크하세요. ")
], -1)
const _hoisted_39 = { class: "step-images" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "guide-step" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "5", -1)
const _hoisted_43 = { class: "step-content" }
const _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"step-title\">다운로드 위치 선택</div><div class=\"step-desc\"> 데이터를 받을 위치를 선택합니다. </div><ul class=\"step-list\"><li><span class=\"highlight\">기기에 다운로드</span> — 모바일 인스타그램 앱에서 다운로드 </li><li><span class=\"highlight\">전송 대상</span> — 구글 드라이브 또는 드롭박스로 전송 (PC 추천) </li></ul>", 3)
const _hoisted_47 = { class: "step-images" }
const _hoisted_48 = ["src"]
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "guide-step" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "6", -1)
const _hoisted_52 = { class: "step-content" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "구글 드라이브 연결", -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "step-desc" }, " 구글 드라이브를 선택하면 계정 로그인 및 권한 확인이 진행됩니다. 빈도 설정을 통해 주기적으로 데이터를 받을 수도 있습니다. ", -1)
const _hoisted_55 = { class: "step-images" }
const _hoisted_56 = ["src"]
const _hoisted_57 = ["src"]
const _hoisted_58 = { class: "guide-step" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "7", -1)
const _hoisted_60 = { class: "step-content" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "JSON 형식 선택 및 파일 만들기", -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "step-desc" }, [
  /*#__PURE__*/_createTextVNode(" 데이터 형식을 반드시 "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight-red" }, "JSON"),
  /*#__PURE__*/_createTextVNode("으로 변경해 주세요. 미디어 품질은 상관없습니다. 확인 후 "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight" }, "파일 만들기"),
  /*#__PURE__*/_createTextVNode("를 클릭하세요. ")
], -1)
const _hoisted_63 = { class: "step-images" }
const _hoisted_64 = ["src"]
const _hoisted_65 = ["src"]
const _hoisted_66 = { class: "guide-step" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "8", -1)
const _hoisted_68 = { class: "step-content" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "파일 생성 대기 및 다운로드", -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("div", { class: "step-desc" }, " 진행 중 목록에 전송 상태가 표시됩니다. 완료까지 다소 시간이 소요됩니다. 완료되면 인스타그램 또는 구글 드라이브에서 파일을 다운로드하세요. ", -1)
const _hoisted_71 = { class: "step-images" }
const _hoisted_72 = ["src"]
const _hoisted_73 = ["src"]
const _hoisted_74 = { class: "guide-step" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "9", -1)
const _hoisted_76 = { class: "step-content" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "step-title" }, "ZIP 파일 업로드", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("div", { class: "step-desc" }, [
  /*#__PURE__*/_createTextVNode(" 다운로드 받은 "),
  /*#__PURE__*/_createElementVNode("span", { class: "highlight-red" }, "ZIP 파일을 그대로 업로드"),
  /*#__PURE__*/_createTextVNode("하면 자동으로 분석됩니다. 압축을 풀 필요가 없습니다. ")
], -1)
const _hoisted_79 = { class: "step-images" }
const _hoisted_80 = ["src"]
const _hoisted_81 = { class: "step-link" }
const _hoisted_82 = {
  key: 1,
  class: "guide-steps"
}
const _hoisted_83 = /*#__PURE__*/_createStaticVNode("<div class=\"guide-step\"><div class=\"step-number\">1</div><div class=\"step-content\"><div class=\"step-title\">인스타그램 설정 이동</div><div class=\"step-desc\"> 인스타그램 앱에서 프로필 화면 오른쪽 상단의 <span class=\"highlight\">≡ (메뉴)</span>를 탭하세요. 그 다음 <span class=\"highlight\">설정 및 개인정보</span>를 선택합니다. </div></div></div><div class=\"guide-step\"><div class=\"step-number\">2</div><div class=\"step-content\"><div class=\"step-title\">계정 센터에서 정보 다운로드</div><div class=\"step-desc\"> 아래 경로를 순서대로 따라가세요. </div><div class=\"step-path\"><span class=\"path-item\">설정 및 개인정보</span><span class=\"path-arrow\">›</span><span class=\"path-item\">계정 센터</span><span class=\"path-arrow\">›</span><span class=\"path-item\">내 정보 및 권한</span><span class=\"path-arrow\">›</span><span class=\"path-item\">내 정보 다운로드</span></div></div></div><div class=\"guide-step\"><div class=\"step-number\">3</div><div class=\"step-content\"><div class=\"step-title\">팔로워 및 팔로잉 데이터 요청</div><div class=\"step-desc\"><span class=\"highlight\">일부 정보</span>를 선택한 후 <span class=\"highlight\">팔로워 및 팔로잉</span> 항목만 체크하세요. </div><div class=\"step-warning\"> 형식은 반드시 <span class=\"highlight-red\">JSON</span>으로 선택해 주세요! </div><div class=\"step-desc\"> 설정 후 <span class=\"highlight\">파일 만들기</span>를 진행하세요. </div></div></div>", 3)
const _hoisted_86 = { class: "guide-step" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "step-number" }, "4", -1)
const _hoisted_88 = { class: "step-content" }
const _hoisted_89 = /*#__PURE__*/_createStaticVNode("<div class=\"step-title\">파일 다운로드 후 업로드</div><div class=\"step-desc\"> 인스타그램에서 파일 준비가 완료되면 알림이 옵니다. 파일을 다운로드한 뒤 <span class=\"highlight-red\">ZIP 파일을 그대로 업로드</span>하거나, 압축 해제 후 <span class=\"highlight\">followers_1.json</span>과 <span class=\"highlight\">following.json</span>을 업로드하세요. </div>", 2)
const _hoisted_91 = { class: "step-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/insta/unfollower",
        class: "hero-cta"
      }, {
        default: _withCtx(() => [
          _createTextVNode("지금 확인하기")
        ]),
        _: 1
      })
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: _normalizeClass(["guide-tab", { active: _ctx.device === 'pc' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.device = 'pc'))
        }, " PC ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["guide-tab", { active: _ctx.device === 'mobile' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.device = 'mobile'))
        }, " Mobile ", 2)
      ]),
      (_ctx.device === 'pc')
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc1.png'),
                    alt: "데이터 다운로드 페이지"
                  }, null, 8, _hoisted_18)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc2.png'),
                    alt: "정보 다운로드 또는 전송"
                  }, null, 8, _hoisted_25)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc3.png'),
                    alt: "계정 선택"
                  }, null, 8, _hoisted_32),
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc4.png'),
                    alt: "일부 정보 항목"
                  }, null, 8, _hoisted_33)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _hoisted_38,
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc5.png'),
                    alt: "팔로워 및 팔로잉 체크"
                  }, null, 8, _hoisted_40)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc6.png'),
                    alt: "다운로드 위치 선택"
                  }, null, 8, _hoisted_48),
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc7.png'),
                    alt: "전송 대상 선택"
                  }, null, 8, _hoisted_49)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc8.png'),
                    alt: "구글 드라이브 선택"
                  }, null, 8, _hoisted_56),
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc9.png'),
                    alt: "구글 계정 로그인"
                  }, null, 8, _hoisted_57)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _hoisted_62,
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc11.png'),
                    alt: "JSON 형식 선택"
                  }, null, 8, _hoisted_64),
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc12.png'),
                    alt: "파일 만들기"
                  }, null, 8, _hoisted_65)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_66, [
              _hoisted_67,
              _createElementVNode("div", _hoisted_68, [
                _hoisted_69,
                _hoisted_70,
                _createElementVNode("div", _hoisted_71, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc13.png'),
                    alt: "전송 진행 중"
                  }, null, 8, _hoisted_72),
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc14.png'),
                    alt: "다운로드 가능"
                  }, null, 8, _hoisted_73)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_74, [
              _hoisted_75,
              _createElementVNode("div", _hoisted_76, [
                _hoisted_77,
                _hoisted_78,
                _createElementVNode("div", _hoisted_79, [
                  _createElementVNode("img", {
                    src: require('@/insta/assets/img/guide/pc15.png'),
                    alt: "다운로드된 ZIP 파일"
                  }, null, 8, _hoisted_80)
                ]),
                _createElementVNode("div", _hoisted_81, [
                  _createVNode(_component_router_link, { to: "/insta/unfollower" }, {
                    default: _withCtx(() => [
                      _createTextVNode("언팔로워 찾으러 가기 →")
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]))
        : (_ctx.device === 'mobile')
          ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
              _hoisted_83,
              _createElementVNode("div", _hoisted_86, [
                _hoisted_87,
                _createElementVNode("div", _hoisted_88, [
                  _hoisted_89,
                  _createElementVNode("div", _hoisted_91, [
                    _createVNode(_component_router_link, { to: "/insta/unfollower" }, {
                      default: _withCtx(() => [
                        _createTextVNode("언팔로워 찾으러 가기 →")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}